import { FC, PropsWithChildren, ReactNode } from 'react';

import { typography } from '../../../typography';

import * as css from './OutlinedButton.css';

type OutlinedButtonProps = {
    isActive?: boolean;
    variant?: 'primary' | 'secondary';
    onClick?: () => void;
    disabled?: boolean;
    icon?: ReactNode;
};

export const OutlinedButton: FC<PropsWithChildren<OutlinedButtonProps>> = ({
    isActive,
    variant,
    onClick,
    disabled,
    icon,
    children,
}) => {
    return (
        <button
            className={css.topButton({
                selected: !!isActive,
                variant: variant ?? 'primary',
            })}
            onClick={(e) => {
                e.stopPropagation();
                onClick?.();
            }}
            disabled={disabled}
        >
            {icon}
            <p
                className={typography({
                    variant: 'h4',
                })}
            >
                {children}
            </p>
        </button>
    );
};
